const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
        .container-video {
            position: relative;
        }
        .video-js {
            width: 660px;
            height: 370px;
        }
        .vjs-poster{
            background-size: 100%!important;
        }
        .vjs-time-tooltip {
            white-space: nowrap;
        }
        .vjs-volume-tooltip {
            white-space: nowrap;
        }
        .vjs-error .vjs-error-display .vjs-modal-dialog-content {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .vjs-error .vjs-error-display:before {
            display: none;
        }
    </style>
</template>`;
styleElement.register("video-player-style");
